import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Box, ColoredDot, colors, Flex } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { PersonChip, Table, Tbody, Td, Th, Thead, Thr, Tr } from '../Accommodation.style'

export const BedHistory = () => {
    return <Flex column gap='1rem' >

        <Box width='100%' >
            <Flex gap='1rem' >
                <CalendarInput labelText='Date From' />
                <CalendarInput labelText='Date To' />
                <HonestSelectInput onChange={null} options={[]} labelText='Camp' />
                <HonestSelectInput onChange={null} options={[]} labelText='Block' />
                <HonestSelectInput onChange={null} options={[]} labelText='Person Type' />
            </Flex>
        </Box>
        <Flex gap='1rem' end='true'>
            <Box>
                <Flex center gap='0.5rem' >
                    <ColoredDot color={colors.blue} />
                    <BodyText color={colors.blue} >Completed</BodyText>
                    <BodyText color={colors.blue} style={{ marginLeft: '0.5rem' }} >150</BodyText>
                </Flex>
            </Box>
            <Box>
                <Flex center gap='0.5rem' >
                    <ColoredDot color={colors.green} />
                    <BodyText color={colors.green} >Active</BodyText>
                    <BodyText color={colors.green} style={{ marginLeft: '0.5rem' }} >150</BodyText>
                </Flex>
            </Box>
            <Box>
                <Flex center gap='0.5rem' >
                    <ColoredDot color={colors.red} />
                    <BodyText color={colors.red} >Overdue</BodyText>
                    <BodyText color={colors.red} style={{ marginLeft: '0.5rem' }} >150</BodyText>
                </Flex>
            </Box>
        </Flex>
        <Table>
            <Thead>
                <Thr>
                    <Th>PERSON</Th>
                    <Th>TYPE</Th>
                    <Th>BED</Th>
                    <Th>LOCATION</Th>
                    <Th>CHECK-IN</Th>
                    <Th>CHECK-OUT</Th>
                    <Th>CHECK-OVERRIDE</Th>
                </Thr>
            </Thead>
            <Tbody>
                <Tr>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>John Smith</TitleText>
                            <OtherText grey>ID: G-001</OtherText>
                        </Flex>
                    </Td>
                    <Td> <PersonChip type='Guest' >Guest</PersonChip></Td>
                    <Td><TitleText>Bed 2</TitleText></Td>
                    <Td><TitleText>East Camp / Block A / Room 2</TitleText></Td>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>10/2/2028</TitleText>
                            <OtherText grey>1:00 PM</OtherText>
                        </Flex>
                    </Td>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>10/2/2028</TitleText>
                            <OtherText grey>1:00 PM</OtherText>
                        </Flex>
                    </Td>
                    <Td><TitleText>No</TitleText></Td>
                </Tr>
                <Tr>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>John Smith</TitleText>
                            <OtherText grey>ID: G-001</OtherText>
                        </Flex>
                    </Td>
                    <Td> <PersonChip type='Guest' >Guest</PersonChip></Td>
                    <Td><TitleText>Bed 2</TitleText></Td>
                    <Td><TitleText>East Camp / Block A / Room 2</TitleText></Td>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>10/2/2028</TitleText>
                            <OtherText grey>1:00 PM</OtherText>
                        </Flex>
                    </Td>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>10/2/2028</TitleText>
                            <OtherText grey>1:00 PM</OtherText>
                        </Flex>
                    </Td>
                    <Td><TitleText>No</TitleText></Td>
                </Tr>
                <Tr>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>John Smith</TitleText>
                            <OtherText grey>ID: G-001</OtherText>
                        </Flex>
                    </Td>
                    <Td> <PersonChip type='Guest' >Guest</PersonChip></Td>
                    <Td><TitleText>Bed 2</TitleText></Td>
                    <Td><TitleText>East Camp / Block A / Room 2</TitleText></Td>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>10/2/2028</TitleText>
                            <OtherText grey>1:00 PM</OtherText>
                        </Flex>
                    </Td>
                    <Td>
                        <Flex column gap='0.5rem' >
                            <TitleText>10/2/2028</TitleText>
                            <OtherText grey>1:00 PM</OtherText>
                        </Flex>
                    </Td>
                    <Td><TitleText>No</TitleText></Td>
                </Tr>
            </Tbody>
        </Table>
    </Flex >
}